import { render } from "./ChangeToRejectModal.vue?vue&type=template&id=337c4130&scoped=true"
import script from "./ChangeToRejectModal.vue?vue&type=script&lang=js"
export * from "./ChangeToRejectModal.vue?vue&type=script&lang=js"

import "./ChangeToRejectModal.vue?vue&type=style&index=0&id=337c4130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337c4130"]])

export default __exports__